/* Shared rows of the landing-page auth consoles. */

export function TraceLine({ label, done }) {
  return (
    <div className="lp-term-line flex items-baseline gap-2 text-[12px]">
      <span className="text-(--color-primary)">▸</span>
      <span className="text-(--lp-term-dim)">{label}</span>
      <span className="min-w-6 flex-1 self-center border-b border-dotted border-(--lp-term-rule)" />
      <span className={done ? "text-(--color-primary)" : "text-(--lp-term-dim)"}>
        {done ? "ok" : "··"}
      </span>
    </div>
  );
}

/* Renders the trace for `steps`, holding the last `ok` until `finished`. */
export function Trace({ steps, step, finished }) {
  return (
    <div className="qv-mono space-y-1.5">
      {steps.map((label, index) => {
        if (!finished && step < index * 2) return null;
        const isLast = index === steps.length - 1;
        return (
          <TraceLine
            key={label}
            label={label}
            done={isLast ? finished : finished || step > index * 2}
          />
        );
      })}
    </div>
  );
}

/* `bare` drops the rule, `>` and caret, for a control that draws its own field. */
export function PromptField({
  label,
  required,
  status,
  children,
  trailing,
  bare,
}) {
  return (
    <label className="block">
      <span className="mb-1.5 flex items-baseline gap-2 text-[11.5px] lowercase tracking-wide text-(--color-primary)">
        {label}
        {required && <span className="text-(--lp-term-err)">*</span>}
        {status && (
          <span className="ml-auto text-[10.5px] text-(--lp-term-dim)">
            {status}
          </span>
        )}
      </span>
      {bare ? (
        children
      ) : (
        <span className="lp-term-field flex items-center gap-2.5 pb-2">
          <span className="text-(--color-primary)">&gt;</span>
          {children}
          <span className="lp-term-caret" />
          {trailing}
        </span>
      )}
    </label>
  );
}
